import { Moment } from "moment";
import { EqualitySymbol, PreReqs } from "../features/models/types/model";
import moment from "moment";
export const dollarsFormat = (value: number) => {
  if (value >= 0) {
    return `$${value}`;
  } else {
    return null;
  }
};
export const truncatedArrayFormat = (value: string[]) => {
  if (value) {
    const arrayLength = value.length;
    const maxLength = 1;
    const needsTruncated = value.length > maxLength;
    if (needsTruncated) {
      return value.map((val, key) => {
        // if the key index is less than or greater than the maxLength, do this
        if (key + 1 <= maxLength) {
          return maxLength !== key + 1
            ? `${val}, `
            : `${val} ... (${arrayLength})`;
        } else {
          return null;
        }
      });
    } else {
      return value.map((val, key) => {
        return arrayLength !== key + 1 ? `${val}, ` : `${val}`;
      });
    }
  } else {
    return null;
  }
};

export const arrayFormat = (value: string[]) => {
  if (value) {
    let arrayLength = value.length;
    return value.map((val, key) => {
      return arrayLength !== key + 1 ? `${val}, ` : `${val}`;
    });
  } else {
    return null;
  }
};

export const percentageFormat = (value: number) => {
  if (value) {
    return `${value} %`;
  } else {
    return null;
  }
};
export const arrayCountFormat = (value: string[]) => {
  if (value) {
    return value.length;
  } else {
    return null;
  }
};

export const dateRangeFormat = (value: Moment[]): string => {
  let start = value[0]
    ? moment(value[0]).format("MM/DD/YYYY")
    : "no date available";
  let end = value[1]
    ? moment(value[1]).format("MM/DD/YYYY")
    : "no date available";
  return `${start} - ${end}`;
};

export const dateFormat = (value: Moment | string): string => {
  return (moment(value).format('MM/DD/YYYY'))
}


export const numberRangeFormat = (value: number[]): string => {
  if (value) {
    let start = value[0];
    let end = value[1];
    return `${start} - ${end}`;
  } else {
    return "";
  }
};

export const toSymbol = (value: EqualitySymbol): string => {
  switch (value) {
    case "E":
      return "=";
    case "GT":
      return ">";
    case "GTE":
      return ">=";
    case "LT":
      return "<";
    case "LTE":
      return "<=";
    case "LK":
      return "~";
    case "NE":
      return "!=";
    default: {
      const exhaustiveCheck: never = value;
      return exhaustiveCheck;
    }
  }
};

export const toPreReq = (value: PreReqs) => PreReqs[value];

export const symbolFormat = (value: [EqualitySymbol, number]) => {
  if (value) {
    let [reqSymbol, reqLimit] = value;
    let symbol;
    switch (reqSymbol) {
      case "E":
        symbol = "=";
        break;
      case "GT":
        symbol = ">";
        break;
      case "GTE":
        symbol = ">=";
        break;
      case "LT":
        symbol = "<";
        break;
      case "LTE":
        symbol = "<=";
        break;
    }
    return symbol ? `${symbol} ${reqLimit} ` : "";
  } else {
    return null;
  }
};

export const truncatedStringFormat = (value: string) => {
  if (value) {
    let firstIndex = value[0] ? value[0] : "";
    return firstIndex.length >= 12
      ? `${firstIndex.substring(0, 12)}...`
      : firstIndex;
  } else {
    return null;
  }
};
